module.exports = __webpack_public_path__ + "static/crescendo_logo.f2223d59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/experience/crescendo_logo.jpg
// module id = 482
// module chunks = 35783957827783